<template>
  <div class="pa-8">
    <div class="">
      <div class="">
        <span class="text-16">Current Stock </span>
        <span class="primary-color-text pl-8">{{stockhistoryarray.Stock}}</span>
      </div>
    </div>
    <v-card outlined flat class="mt-5">
      <v-data-table
        :headers="headers"
        :loading="tableLoader"
        loading-text="Loading... Please wait"
        :items="GetStockHistorty"
        :items-per-page="displayedItemsPerPage"
        hide-default-footer
      >
        <template v-slot:[`item.index`]="{ index }">
          <b class="index_index_text">
            {{ index + 1 }}
          </b>
        </template>
        <template v-slot:[`item.date`]="{ item }">
          <span class="table_style_two">
            {{
              item.Date == null
                ? new Date().toISOString().split("T")[0]
                : item.Date.split("T")[0]
            }}
          </span>
        </template>

        <template v-slot:[`item.stock`]="{ item }">
          <div class="d-flex">
            <span class="text-14">
              {{ item.AddedStock }}
              <span class="index-head"> ({{ item.RemovedStock }})</span></span
            >
          </div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["stockhistoryarray"],
  data() {
    return {
      tableLoader: true,

      headers: [
        { text: "#", value: "index" },
        { text: "Date", value: "date" },
        { text: " Stock adjusted", value: "stock" },
        { text: "", value: "actions", sortable: false },
      ],
      DataTableOne: [],
    };
  },
  mounted() {
    this.tableLoader = true;
    this.$store
      .dispatch("GetStockHistorty", this.stockhistoryarray.Id)
      .then(() => {
        this.tableLoader = false;
      });
  },
  computed: {
    ...mapGetters(["GetStockHistorty"]),
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.text-head {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 31px;
  color: #222222;
}
.text-16 {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  color: #222222;
}
.text-14 {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: #222222;
}
.primary-color-text {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;

  color: #0071bd;
}
.index-head {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: rgba(8, 8, 22, 0.38);
}
</style>
